import React from "react";
import { SiBehance, SiGithub, SiLinkedin, SiMedium } from "react-icons/si";
import { SOCIALS } from "../../data/socials";
import "./SocialLinks.css";

const ICONS = {
  linkedin: SiLinkedin,
  behance: SiBehance,
  github: SiGithub,
  medium: SiMedium,
};

const SocialLinks = ({ className = "" }) => (
  <nav className={`social-links${className ? ` ${className}` : ""}`} aria-label="Social links">
    {SOCIALS.map((item) => {
      const Icon = ICONS[item.id];
      return (
        <a
          key={item.href}
          href={item.href}
          target="_blank"
          rel="noreferrer"
          aria-label={item.label}
          title={item.label}
        >
          {Icon ? <Icon aria-hidden="true" /> : item.label}
        </a>
      );
    })}
  </nav>
);

export default SocialLinks;
